
Grid = window.Grid || {};


Grid.FilterComponent = {
    	templateUrl: 'framework/partials/grid/filter.html',
    	bindings: {
    		listController: '=',
    	},
 		controllerAs: 'filterCtrl',
    	controller: function($scope, FieldTplDir, $timeout) {
    		var self = this;
    		
    		this.fieldTplDir = FieldTplDir;
    		this.fields = this.listController.Class.get_fields('filter').filter(function(field){return self.listController.Class.perms[field.listperm]});
    		if (this.fields.length > 0) {
    			// activate pager's filter icon
    			this.listController.state.showSearch = this.listController.state.showSearch || null;  // ng-if, let the pager know
    		}
    		var search_timeout = null;
			
			$scope.$watch('filter', function(filter, oldfilter) {
				if (filter === oldfilter) return;
				$timeout.cancel(search_timeout);
				search_timeout = $timeout(function(){
						var query = {};
						// sanitize filter
						for (var k in filter) {
							var v = filter[k];
							if (typeof v == "undefined" || v === null || v === "" || v.length === 0) {
								//delete $scope.filter[k];
								continue;
							}
							if (typeof v == "string" && k.indexOf('~')>0) v = v.replace(/[^0-9A-Za-z\u00C0-\u017F @_\-.]/g, '');
							if (typeof v.from != "undefined" && typeof v.to != "undefined") {
								if (v.from != null && v.to != null) {
									v = '[' + v.from + ',' + v.to + ']';
								} else continue;
							}
							query[k] = angular.copy(v); 
						}
						if (!angular.equals(query, self.listController.params.filter)) {
							self.listController.params.offset = 0;
							//self.listController.params.filter = query;
							self.listController.setFilter(query);
							self.listController.getPage();
						}
				}, 200);
			}, true);
			
			//$scope.$watch(function(){return self.listController.params.filter}, function(filter) {
			this.controllerFilterChanged = function(filter){
				$scope.filter = angular.copy(filter);
				for (var k in filter) {
					var v = filter[k];
					var matches;
					if (typeof v == "string" && (matches = v.match(/[\[\(](.*),(.*)[\]\)]/))) {
						v = {from: matches[1], to: matches[2]}
					}
					$scope.filter[k] = angular.copy(v); 
				}
			}
			this.listController.setFilter.subscribe(this.controllerFilterChanged);
			$scope.filter = {};
	        this.controllerFilterChanged(self.listController.params.filter)
			
			
			this.has_filter = function(fieldname) {  // dla search-box
	        	for (var i in $scope.fieldname2filter[fieldname]) {
	        		var recipe = $scope.fieldname2filter[fieldname][i];
	        		if (!recipe) continue;
	        		var expr = $scope.$eval(recipe, {field:self.listController.Class.fields[fieldname]}) || fieldname;
	        		if ($scope.filter[expr]) return true;
	        	}
	        	return false;
	        }
	        
	        // leagcy stuff
	        $scope.create_mode = true; // do we need this?
	        $scope.fieldname2filter = {}
	        $scope.cls = this.listController.Class
    		
    		window.filterCtrl = this;
    		
    	}
}



// TODO - isolate scope, 
Grid.FilterComponentField = function() {
    return {
    	scope: true,
    	link: function(scope, element, attrs) {
			scope.create_mode = true;
			scope.object = {};
			scope.fieldname2filter[scope.field.name] = [];
			scope.fieldname2filter[scope.field.name].push(attrs.expr || scope.field.name)
			scope.fieldname2filter[scope.field.name].push(attrs.expr2);
		}
	}
};